import {
    createContext, MutableRefObject,
} from 'react'
import {
    TableFilterParams,
} from 'app/types/common.types'

export type TableActionsContextValue = {
    bulkUploadData: TableFilterParams | null
    setBulkUploadData: (data: TableFilterParams | null) => void
    invalidateTableDataRef: MutableRefObject<() => void>
}

const TableActionsContext = createContext<TableActionsContextValue | undefined>(undefined)

export default TableActionsContext
